import React, { FC, ReactNode } from 'react'

import { Loading } from '../../Loading'
import { EmptyResultsContainer } from '../AutoSizeGrid.styles'

interface EmptyResultsProps {
  width: number
  height: number
  emptyDataComponent?: ReactNode
  isLoadingContent?: boolean
}

export const EmptyResults: FC<EmptyResultsProps> = ({
  width,
  height,
  isLoadingContent,
  emptyDataComponent,
}) => {
  const renderContent = () => {
    if (isLoadingContent) {
      return <Loading />
    }

    return emptyDataComponent || <></>
  }

  return (
    <EmptyResultsContainer width={width} height={height}>
      {renderContent()}
    </EmptyResultsContainer>
  )
}
